import { render, staticRenderFns } from "./RsaSchedaOspiteDimissioneTrasferimentoComponent.vue?vue&type=template&id=2909bb5a&scoped=true"
import script from "./RsaSchedaOspiteDimissioneTrasferimentoComponent.vue?vue&type=script&lang=js"
export * from "./RsaSchedaOspiteDimissioneTrasferimentoComponent.vue?vue&type=script&lang=js"
import style0 from "./RsaSchedaOspiteDimissioneTrasferimentoComponent.vue?vue&type=style&index=0&id=2909bb5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2909bb5a",
  null
  
)

export default component.exports